// extracted by mini-css-extract-plugin
export var fullWidthButton = "_og-0";